import React from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import ArrowLeft from '@rover/icons/svg/arrow-left.svg';
import { Box, Button, Flex, Heading, Paragraph } from '@rover/kibble/core';

type ContentProps = {
  onClose?: () => void;
  onBack?: () => void;
};

const AutomaticRecordContent = ({ onClose, onBack }: ContentProps): JSX.Element => {
  const { t } = useLingui();
  return (
    <Box p="4x">
      <Flex>
        {onBack && (
          <Box
            width="24px"
            height="24px"
            p="1x"
            onClick={onBack}
            data-testid="back-arrow-button"
            aria-label={t`Go back to reviews list`}
            role="button"
            sx={{ cursor: 'pointer' }}
          >
            <ArrowLeft width="100%" height="100%" aria-hidden="true" />
          </Box>
        )}
        <Heading size="300">
          <Trans>Cancellation</Trans>
        </Heading>
      </Flex>
      <Paragraph size="200">
        <Trans>
          This automatic message is posted each time a provider cancels a booking on short notice.
          Sometimes last-minute cancellations can't be helped, but it's hard to find alternative pet
          care when they do happen.
        </Trans>
      </Paragraph>
      {onClose && (
        <Box py="2x" mx="1x">
          <Button fullWidth onClick={onClose}>
            <Trans>Close</Trans>
          </Button>
        </Box>
      )}
    </Box>
  );
};
export default AutomaticRecordContent;
